// extracted by mini-css-extract-plugin
export default {"headingUnderline":"SectionBanner_headingUnderline__hsVWi","SectionBanner":"SectionBanner_SectionBanner__9jODU"};